import Vue from 'vue'
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate'
import {
  required,
  confirmed,
  alpha_spaces as alphaSpaces,
} from 'vee-validate/dist/rules'

Vue.component('VInput', ValidationProvider)
Vue.component('VForm', ValidationObserver)

extend('required', {
  ...required,
  message: 'O campo {_field_} não pode ser nulo.',
})
extend('min', {
  validate(value, { min }) {
    return value.length >= min
  },
  params: ['min'],
  message: (fieldName, placeholders) => {
    return `O campo ${fieldName} deve ter pelo menos ${placeholders.min} caracteres`
  },
})
extend('confirmed', {
  ...confirmed,
  message: 'A confirmação de senha não confere',
})

extend('alpha_spaces', {
  ...alphaSpaces,
  message: 'O campo {_field_} só pode conter caracteres alfabéticos e espaços.',
})

// Número do cartão: 15 dígitos (Amex) ou 16 (demais bandeiras), ignorando os
// espaços da máscara.
extend('card_number', {
  validate(value) {
    const digits = value.replace(/\D/g, '')
    return digits.length === 15 || digits.length === 16
  },
  message: 'O número do cartão deve ter 15 ou 16 dígitos.',
})

// Validade do cartão no formato MM/AA: mês entre 01 e 12 e cartão não vencido
// (o cartão vale até o último dia do mês informado).
extend('card_expiration', {
  validate(value) {
    const [, month, year] = value.match(/^(\d{2})\/(\d{2})$/) || []
    if (!month) return 'Informe a validade no formato MM/AA.'
    if (month < 1 || month > 12) return 'Mês da validade inválido.'

    const today = new Date()
    const currentYear = today.getFullYear() % 100
    const currentMonth = today.getMonth() + 1
    const isExpired =
      Number(year) < currentYear ||
      (Number(year) === currentYear && Number(month) < currentMonth)

    return isExpired ? 'Cartão vencido.' : true
  },
})
